import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader, Progress } from "reactstrap";

const DisconnectAlert = (props) => {
  const { isOpen, title, text } = props;

  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        <div className="mb-3">{text}</div>
        {props?.showRefreshButton ? (
          <>
            <div className="text-right">
              <button
                className="btn btn-primary"
                onClick={() => {
                  window.location.reload();
                }}
              >
                {t("Refresh")}
              </button>
            </div>
          </>
        ) : (
          <Progress animated color="info" value={100} />
        )}
      </ModalBody>
    </Modal>
  );
};

export default DisconnectAlert;
